import { useRef, useEffect, useState, MutableRefObject } from 'react';

interface Props {
    textValue?: string;
}

// Pass `textValue` if the element text is dynamic and you want to recalculate `isEllipsis`

export function useEllipsis<T extends HTMLElement>({ textValue }: Props = {}): [
    MutableRefObject<T>,
    boolean
] {
    const elemRef = useRef<T>(null);
    const [isEllipsisActive, setIsEllipsisActive] = useState(false);

    useEffect(() => {
        if (!elemRef.current) {
            return;
        }
        setIsEllipsisActive(
            elemRef.current.scrollWidth > elemRef.current.offsetWidth
        );
    }, [textValue]);

    return [elemRef, isEllipsisActive];
}
